import FlashPlugin from './FlashPlugin';

const VIDEO_OPTIONS = {
   prefix: 'flash_video',
   filename: 'ravnur-flash-video.swf',
   enablePseudoStreaming: false,
   // start query parameter sent to server for pseudo-streaming
   pseudoStreamingStartQueryParam: 'start',
   // pseudo streaming type: use `time` for time based seeking (MP4) or `byte` for file byte position (FLV)
   pseudoStreamingType: 'byte'
};

const HLS_OPTIONS = {
   prefix: 'flash_hls',
   filename: 'ravnur-flash-video-hls.swf'
};

const AUDIO_OPTIONS = {
   prefix: 'flash_audio',
   filename: 'ravnur-flash-audio.swf'
};

const SUPPORTED_VIDEO_FORMATS = ['video/mp4', 'video/flv', 'video/rtmp', 'audio/rtmp', 'rtmp/mp4', 'audio/mp4'];
const SUPPORTED_HLS_FORMATS = ['audio/hls', 'video/hls', 'application/x-mpegURL',
   'application/x-mpegurl', 'vnd.apple.mpegURL', 'audio/ism/manifest(format=m3u8-aapl-v3)'];

// VIDEO
export const VIDEO = new FlashPlugin('flash_video', VIDEO_OPTIONS, SUPPORTED_VIDEO_FORMATS);
// HLS
export const HLS = new FlashPlugin('flash_hls', HLS_OPTIONS, SUPPORTED_HLS_FORMATS);
// AUDIO
export const AUDIO = new FlashPlugin('flash_audio', AUDIO_OPTIONS, ['audio/mp3']);
